import { defineComponent, watch } from 'vue';
import { useField } from 'vee-validate';
import ErrorMessageLabel from '@hems/component/src/labels/ErrorMessageLabel.vue';
import { Helper } from '@hems/util';
import BasicRadio from './BasicRadio.vue';
export default defineComponent({
    name: 'RadioGroup',
    components: {
        BasicRadio,
        ErrorMessageLabel,
    },
    inheritAttrs: false,
    emits: ['update:modelValue'],
    props: {
        name: String,
        modelValue: {
            type: [String, Number, Boolean],
            required: true,
        },
        maxColumnNum: {
            type: Number,
            default: 4,
        },
        options: {
            type: Array,
            required: true,
        },
        direction: {
            type: String,
            default: 'row',
        },
        align: {
            type: String,
            default: 'left',
        },
        valueType: {
            type: String,
            default: 'string',
        },
    },
    setup(props, { emit }) {
        const inputName = props.name || Helper.getUUID();
        const { value: inputValue, errorMessage } = useField(inputName, undefined, {
            initialValue: props.modelValue,
            type: props.valueType,
        });
        watch(() => inputValue.value, () => {
            emit('update:modelValue', inputValue.value);
        });
        watch(() => props.modelValue, () => {
            if (inputValue.value !== props.modelValue)
                inputValue.value = props.modelValue ?? '';
        });
        return {
            errorMessage,
            inputValue,
            inputName,
        };
    },
});
